import { connect } from 'react-redux';
import Profile from './components/Profile';
import {
  updateUserProfile,
  updateOrganization,
  uploadPhoto,
} from '../../redux/actions/user';
import {
  loadSplunk,
  updateSplunk,
  saveSplunk,
  deleteSplunk,
} from '../../redux/actions/integrations';
import {
  loadUser,
  loadMySubscriptionPlan,
  loadOrganization,
} from '../../redux/actions/user';

const mapStateToProps = (state) => ({
  token: state.auth.token,
  user: state.user.user,
  organization: state.user.organization,
  status: state.user.status,
  splunkSettings: state.integration.splunkSettings,
  photoUploadStatus: state.user.photoUploadStatus,
  photoUploadData: state.user.photoUploadData,
  mySubscriptionPlan: state.user.mySubscriptionPlan,
  mySubscriptionPlanStatus: state.user.mySubscriptionPlanStatus,
});

const mapDispatchToProps = {
  updateUserProfile,
  updateOrganization,
  loadSplunk,
  updateSplunk,
  saveSplunk,
  deleteSplunk,
  loadUser,
  loadOrganization,
  uploadPhoto,
  loadMySubscriptionPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
